/* Student testimonials.

   Renders NOTHING while there are no entries for this course - no heading, no
   placeholder copy, no empty boxes. Entries are added in
   src/config/educations.mjs (TESTIMONIALS); see the comment there. */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { testimonialsFor } from '../../config/educations.mjs';
import { Section, Heading, INK, BODY, BRAND, serif, sans } from '../ui/blocks';

const Testimonials = ({ kurs, headingKey }) => {
  const { t } = useTranslation();
  const items = testimonialsFor(kurs);

  if (items.length === 0) return null;

  return (
    <Section tinted>
      <Heading align="center">{t(headingKey)}</Heading>

      <div style={{ display: 'grid', gap: '20px' }}>
        {items.map((item, i) => (
          <figure
            key={i}
            style={{
              margin: 0,
              display: 'flex',
              flexWrap: 'wrap',
              gap: '22px',
              alignItems: 'flex-start',
              padding: '26px',
              borderRadius: '20px',
              background: '#fff',
              border: '1px solid rgba(144,81,15,0.14)',
            }}
          >
            {item.slika && (
              <img
                src={item.slika}
                alt={item.ime}
                loading="lazy"
                width="96"
                height="96"
                style={{
                  width: '96px',
                  height: '96px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  flexShrink: 0,
                }}
              />
            )}
            <div style={{ flex: '1 1 260px' }}>
              <blockquote
                style={{
                  margin: 0,
                  fontFamily: sans,
                  fontSize: '16px',
                  lineHeight: 1.85,
                  color: BODY,
                  fontStyle: 'italic',
                }}
              >
                {item.tekst}
              </blockquote>
              <figcaption
                style={{
                  marginTop: '14px',
                  fontFamily: serif,
                  fontSize: '18px',
                  fontWeight: 600,
                  color: INK,
                }}
              >
                <span style={{ color: BRAND }}>-</span> {item.ime}
              </figcaption>
            </div>
          </figure>
        ))}
      </div>
    </Section>
  );
};

export default Testimonials;
